<template>
  <div class="container">
    <div class="bg-fff pa-20">
      <div class="fon-18 font-bold b-b-1-e3 pa-b-10">票种信息</div>
      <el-row
        type="flex"
        justify="space-between"
        class="bg-fff ma-t-20 f-wrap b-e3"
      >
        <el-col :xs="24" :sm="4" class="">
          <div class="tab-h">
            <span class="b-l-1-738 pa-l-10">票种名称</span>
          </div>
          <div class="pa-20">
            <div>{{ detail.Name }}</div>
            <div class="c-666">(剩余{{ detail.LessCount }}张)</div>
          </div>
        </el-col>

        <el-col :xs="24" :sm="4" class="">
          <div class="tab-h"><span class="b-l-1-738 pa-l-10">单价</span></div>
          <div class="pa-20">￥{{ detail.Price }}</div>
        </el-col>

        <el-col :xs="24" :sm="4" class="">
          <div class="tab-h"><span class="b-l-1-738 pa-l-10">数量</span></div>
          <div class="pa-20">
            <el-input-number
              v-model="count"
              :min="1"
              size="small"
              @change="changecount"
            ></el-input-number>
          </div>
        </el-col>

        <el-col :xs="24" :sm="4" class="">
          <div class="tab-h">
            <span class="b-l-1-738 pa-l-10">小计</span>
          </div>
          <div class="pa-20">￥{{ detail.Price * count }}</div>
        </el-col>
      </el-row>
    </div>

    <div class="bg-fff ma-t-20 pa-20">
      <div class="fon-18 font-bold b-b-1-e3 pa-b-10">填写报名信息</div>
      <div
        v-for="(item, index) in members"
        :key="index"
        class="b-b-1-e3 pa-b-10"
      >
        <div class="b-b-1-e3 pa-b-10 font-bold ma-t-20">
          用户{{ index + 1 }}
        </div>
        <div class="ma-t-10">
          <div class="c-666">姓名</div>
          <div class="width50 ma-t-10">
            <el-input v-model="item.Name" placeholder="请输入姓名"></el-input>
          </div>
        </div>
        <div class="ma-t-20">
          <div class="c-666">手机</div>
          <div class="width50 ma-t-10">
            <el-input
              v-model="item.Phone"
              placeholder="请输入手机号"
            ></el-input>
          </div>
        </div>
      </div>
    </div>

    <div class="pa-20 bg-fff flex f-end ma-t-20 ma-b-20">
      <div class="flex baoming f-between f-center">
        <div>
          共：<span class="c-red">{{ count }}</span
          >张
        </div>
        <div>
          总金额：<span class="c-red">￥{{ detail.Price * count }}</span>
        </div>
        <div class="apply-btn" @click="btnAddOrder">立即报名</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getActivityItemDetail,
  postActivityApply,
  orderPay
} from '../../api.js'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      temp: 1,
      amountData: {},
      projectData: {},
      amountId: '',
      itemId: '',
      projectId: '',
      detail: {},
      count: 1,
      members: [
        {
          Name: '',
          Phone: ''
        }
      ],
      projectName: '' //项目名称
    }
  },
  activated() {
    this.itemId = this.$route.query.itemId
    this.loadData()
  },
  beforeRouteEnter(to, from, next) {
    window.scroll(0, 0)

    next()
  },
  methods: {
    //微信内支付
    wxPay(weixin) {
      var _this=this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有 api 的返回值会在客户端 alert 出来，若要查看传入的参数，可以在 pc 端打开，参数信息会通过 log 打出，仅在 pc 端时才会打印。
        appId: weixin.AppId, // 必填，公众号的唯一标识
        timestamp: weixin.TimeStamp, // 必填，生成签名的时间戳
        nonceStr: weixin.NonceStr, // 必填，生成签名的随机串
        signature: weixin.PaySign, // 必填，签名
        jsApiList: ['chooseWXPay'] // 必填，需要使用的 JS 接口列表
      })
      wx.ready(function () {
        //发起微信支付
        wx.chooseWXPay({
          timestamp: weixin.TimeStamp, // 支付签名时间戳，注意微信 jssdk 中的所有使用 timestamp 字段均为小写。但最新版的支付后台生成签名使用的 timeStamp 字段名需大写其中的 S 字符
          nonceStr: weixin.NonceStr, // 支付签名随机串，不长于 32 位
          package: weixin.Package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          signType: weixin.SignType, // 微信支付V3的传入 RSA ,微信支付V2的传入格式与V2统一下单的签名格式保持一致
          paySign: weixin.PaySign, // 支付签名
          success: function () {
            _this.$alert('支付成功', '提示', {
              confirmButtonText: '确认',
              showClose: false,
              type: 'success'
            })
              .then(() => {
                // 支付成功后的回调函数
                _this.$router.push({
                  path: '/event/detail',
                  query: {
                    id: _this.detail.ActivityId
                  }
                })
              })
              .catch(() => {})
          }
        })
      })
    },
    changecount() {
      var arr = []
      for (let index = 0; index < this.count; index++) {
        arr.push({
          Name: '',
          Phone: ''
        })
      }
      this.members = arr
    },
    //获取众筹信息
    loadData() {
      getActivityItemDetail({ id: this.itemId }).then((res) => {
        this.detail = res.data.Data
      })
    },
    //下单
    btnAddOrder() {
      //判断是否在微信浏览器里，如果在微信支付时使用微信支付，否则使用扫码支付
      var ua = navigator.userAgent.toLowerCase()
      this.isWeixin = ua.indexOf('micromessenger') != -1
      let openid = localStorage.getItem('openid')
      console.log(openid)
      //如果微信浏览器中没有openid就重新登录
      if (this.isWeixin && !openid) {
        this.$router.push('/Login')
        return
      }
      let token = localStorage.getItem('AccessToken')
      if (!token) {
        this.$alert('您还未登录请先登录', '提示', {
          confirmButtonText: '去登录',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.$router.push('/Login')
          })
          .catch(() => {})
        return
      }
      var ok = true
      var me = this.members
      me.forEach((item, index) => {
        if (item.Name == '') {
          this.$message({
            message: '请填写用户' + (index + 1) + '的姓名',
            type: 'warning'
          })
          ok = false
          return
        }
        //数据验证
        if (!item.Phone) {
          this.$message({
            message: '请填写用户' + (index + 1) + '手机号',
            type: 'warning'
          })
          ok = false
          return
        }
        if (!/^1\d{10}$/.test(item.Phone)) {
          this.$message({
            message: '用户' + (index + 1) + '的手机号格式错误',
            type: 'warning'
          })
          ok = false
          return
        }
      })
      if (!ok) return
      postActivityApply({
        Id: this.detail.ActivityId,
        ItemId: this.itemId,
        Count: this.count,
        Info: this.members
      }).then((res) => {
        console.log(res.data.Data)
        if (this.isWeixin) {
          orderPay({
            Key: res.data.Data.Key,
            Type: this.isWeixin ? 'weixinm' : 'weixin',
            OpenId: openid
          }).then((res) => {
            this.wxPay(res.data.Data.Data)
          })
        } else {
          this.$router.push({
            path: '/event/pay-2',
            query: {
              Key: res.data.Data.Key,
              amount: res.data.Data.Amount,
              id:this.detail.ActivityId
            }
          })
        }
      })
    }
  },
  computed: {
    totalPrice() {
      return (
        this.formData.Count * this.amountData.Price +
        Number(this.formData.OtherAmount)
      ).toFixed(2)
    }
  }
}
</script>

<style  lang="scss" scoped>
.baoming {
  width: 50%;
}
@media (max-width: 768px) {
  .baoming {
    width: 100%;
  }
  .apply-btn {
    width: 30%;
    padding: 10px !important;
    text-align: center;
  }
}

.box-line-bottom {
  padding-bottom: 20px;
  border-bottom: 1px solid #738292;
}
.tab-h {
  background: #edeeef;
  color: #738292;
  padding: 10px;
}
.b-r-1-eee {
  border-right: 1px solid #eee;
}
.b-l-1-738 {
  border-left: 1px solid #ced3da;
}

.b-l-1-ee {
  border-left: 1px solid #eee;
}
.stop {
  .iconfont {
    font-size: 50px;
  }
}
.c-yellow {
  color: #f8ab6b;
}
.apply-btn {
  padding: 10px 70px;
  background: #fb004d;
  display: inline-block;
  color: #fff;
  cursor: pointer;
}
</style>